import { z } from 'zod'
import { CategoryType } from '../../enums/category-type.enum'
import { IncomeType } from '../../enums/income-type.enum'

export const createCategorySchema = z
  .object({
    name: z.string().min(1, 'Name is required').max(100),
    type: z.nativeEnum(CategoryType),
    description: z.string().max(500).optional(),
    color: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/, 'Color must be a valid hex color')
      .optional(),
    groupId: z.string().guid().optional(),
    incomeType: z.nativeEnum(IncomeType).optional(),
  })
  .transform((data) => ({
    ...data,
    incomeType:
      data.type === CategoryType.INCOME ? (data.incomeType ?? IncomeType.ACTIVE) : undefined,
  }))

export type CreateCategoryDto = z.infer<typeof createCategorySchema>
